import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FormDrawer from '~/components/FormDrawer';
import { ApplicationPayload } from '~/types/ApplicationPayload';

import buildNamePath from '~/utils/buildNamePath';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import merge from '~/utils/mergeWithUndefined';
import BeneficialOwnerForm, {
  formName,
  getBeneficialOwnersFormItemsNamePath,
} from '~/pages/ksa/application/shareholders/components/beneficialOwners/BeneficialOwnerForm';
import { isEditButtonDisabled } from '~/components/views/ShareholdersMultiple/utils';
import { hasAnyDeclinedField } from '~/pages/ksa/application/shareholders/components/beneficialOwners/BeneficialOwnerTable';
import { useGetApplication } from '~/controllers/wizard';

interface Props extends Partial<FormItemInjectedProps<KsaShareholders>> {
  uid: string;
  onClose: () => void;
}

const BeneficialOwnerEdit: FC<Props> = (props) => {
  const { uid, onClose } = props;
  const { value, onChange } = props as FormItemInjectedProps<KsaShareholders>;
  const shareholdersFormState = { shareholders: value };
  const applicationQuery = useGetApplication();
  const { t } = useTranslation('fillApplication');

  const currentIndex =
    shareholdersFormState.shareholders?.beneficialOwners?.findIndex((item) => item?.uid === uid) ||
    0;

  const onFinish = (newValues: ApplicationPayload) => {
    const updatedData = merge(shareholdersFormState, newValues);
    onChange?.(updatedData.shareholders);
    onClose();
  };

  const withContinueButton = !isEditButtonDisabled(
    applicationQuery.data,
    hasAnyDeclinedField(applicationQuery.data)
  );

  return (
    <FormDrawer
      id="beneficialOwnerEditDrawer"
      visible={!!uid}
      onClose={onClose}
      title={t('Edit beneficial owner')}
      formName={formName}
      withContinueButton={withContinueButton}
    >
      <BeneficialOwnerForm
        onFinish={onFinish}
        n={buildNamePath(getBeneficialOwnersFormItemsNamePath(currentIndex))}
        initialValues={shareholdersFormState}
      />
    </FormDrawer>
  );
};

export default BeneficialOwnerEdit;
